export default __webpack_public_path__ + "static/media/Group_2.4f3b4bf1.svg";